/**
 * "작성 중인 글이 있는가"를 DOM 에서 판정한다.
 *
 * 언어 토글은 reload 로 로케일을 반영하는데(사유는 LanguageToggle 주석 참고), reload 는
 * URL·localStorage 밖의 React 상태를 전부 버린다. 헤더는 글쓰기 화면에도 떠 있으므로
 * (journal/new, journal/:id/edit, board/idea|feed/write, community/real-estate/write —
 * 전부 MainLayout 안), 작성 중에 토글을 누르면 본문이 조용히 사라진다.
 *
 * 판정 대상을 textarea·contenteditable 로 한정한 이유:
 * 이들이 "본문 작성" 표면이다. 검색바·필터는 <input> 이라 대상에서 빠지므로,
 * 검색어를 입력했다는 이유로 확인창이 뜨는 오탐이 생기지 않는다.
 * (제목만 쓰고 본문은 비운 상태는 놓치지만, 그 경우 손실이 한 줄이라 오탐 비용이 더 크다고 봤다.)
 *
 * DOM 을 인자로 받는 순수 함수 — 렌더 없이 단위 테스트 가능하다.
 */
export function hasUnsavedComposition(root: ParentNode): boolean {
  const textareas = [...root.querySelectorAll('textarea')];
  const editables = [...root.querySelectorAll('[contenteditable="true"]')];

  const hasFilledTextarea = textareas.some((el) => el.value.trim().length > 0);
  const hasFilledEditable = editables.some(
    (el) => (el.textContent ?? '').trim().length > 0,
  );

  return hasFilledTextarea || hasFilledEditable;
}
